<button
    class="o-step-indicator__dropdown-step-button"
    role="tab"
    tgRackItem
    link
    linkColor
    [attr.aria-expanded]="item.active"
    [attr.aria-controls]="item.active ? 'content-' + item.id : null"
    [attr.id]="'nav-' + item.id"
    [class.o-step-indicator__dropdown-step-button--is-active]="item.active"
    [class.o-step-indicator__dropdown-step-button--is-disabled]="item.disabled"
    [disabled]="item.disabled"
    (click)="select()"
>
    <tg-rack-item-primary>
        <span class="o-step-indicator__step">
            {{ item.title }}
        </span>
    </tg-rack-item-primary>
    <tg-rack-item-suffix *ngIf="item.icon">
        <ng-container *ngTemplateOutlet="item.icon"> </ng-container>
    </tg-rack-item-suffix>
</button>
